<div class="background" [style.background]="hcService.getHcConfig().firstAccess.background">
  <div class="layout">
    <header class="header" *ngIf="!shouldHideHeader">
      <img
        [src]="hcService.getHcConfig().firstAccess.logo.src"
        [width]="hcService.getHcConfig().firstAccess.logo.width"
        [height]="hcService.getHcConfig().firstAccess.logo.height"
        alt="Logo"
      />
    </header>
    <main>
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
